<template>
    <div>

        <h2>Registreringssida</h2>

        <div class="custom-form-section">

            <div class="form-check form-check-lg mb-0">
                <input class="form-check-input" type="checkbox" value="" id="customer-register-page-active" v-model="form.open_registration_is_active">
                <label class="form-check-label" for="customer-register-page-active">
                    Aktivera registreringssida
                </label>
            </div>

            <div class="custom-info pt-0">Om registreringssidan aktiveras så skapas en URL där de anställda själva kan
                registrera sina konton.<br>Om sidan väjs bort behöver Hälsoresurs eller kunden lägga in alla konton.
            </div>

            <div class="register-page-container mt-6" :class="{ 'd-none' : !form.open_registration_is_active }">

                <label class="form-label mb-0">Sidans adress</label>
                <div style="font-size: 18px; font-weight: 600;" class="mb-8"><a
                    :href="company.registration_url" target="_blank">{{ company.registration_url }}</a>
                </div>

                <div class="custom-form-group">
                    <img :src="'/storage/open-registration-images/'+form.open_registration_image" class="mb-2" style="height: 300px; max-width: 100%;" v-if="form.open_registration_image">
                    <div class="mb-5" v-if="form.open_registration_image">
                        <button class="btn btn-sm btn-danger" @click="form.open_registration_image = null">
                            Ta bort bild
                        </button>
                    </div>
                    <label for="customer-register-page-image" class="form-label">Bild</label>
                    <input class="form-control" type="file" id="customer-register-page-image" @change="upload">
                    <div class="custom-info">Rekommenderad storlek: 1600 x 400 pixlar. Om du inte laddar upp någon bild
                        så visas en standardbild.
                    </div>
                </div>

                <div class="custom-form-group">
                    <label class="form-label" for="customer-register-page-title">Titel</label>
                    <input type="text" id="customer-register-page-title" class="form-control" v-model="form.open_registration_title">
                    <div class="custom-info">Exempelvis företagets namn.</div>
                </div>

                <div class="custom-form-group">
                    <label class="form-label" for="customer-register-page-content">Brödtext</label>
                    <textarea id="customer-register-page-content" class="form-control" style="height: 300px;" v-model="form.open_registration_text"></textarea>
                </div>

            </div>

            <div class="d-flex justify-content-end">
                <button class="btn btn-primary" :disabled="patcher.submitted" @click="patcherPatch()">
                    <span class="spinner-border spinner-border-sm"></span>
                    Spara
                </button>
            </div>

        </div>

    </div>

</template>

<script>

import patcher from '../../../../shared/mixins/patcher'
import axios from 'axios'

export default {

    mixins: [
        patcher
    ],

    props: {
        company: {
            required: true
        }
    },

    data () {
        return {
            form: {
                open_registration_image: this.company.open_registration_image,
                open_registration_is_active: this.company.open_registration_is_active,
                open_registration_title: this.company.open_registration_title,
                open_registration_text: this.company.open_registration_text
            }
        }
    },

    computed: {
        patcherUrl () {
            return '/companies/' + this.company.id
        },
        patcherData () {
            return this.form
        }
    },

    methods: {

        upload (event) {
            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('file', files[0], files[0].name)

            axios.post(
                '/companies/' + this.company.id + '/openRegistrationImageUpload',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.form.open_registration_image = response.data.open_registration_image
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
        },

        patcherSuccess (data) {
            bus.$emit(
                'notify',
                'Ändringarna har sparats'
            )
        }
    }

}
</script>
